import { AuthorizationTemplate } from 'hooks/useAuthorize'
import { BaseRole } from 'types/user'

export const AGENCIES_ACTION: AuthorizationTemplate = {
  EDIT: { roles: [BaseRole.EMPLOYEE, BaseRole.ADMIN] },
  REMOVE: { roles: [BaseRole.EMPLOYEE, BaseRole.ADMIN] },
}
